import { render, staticRenderFns } from "./overlay-loading.vue?vue&type=template&id=53c9ef24&scoped=true"
import script from "./overlay-loading.vue?vue&type=script&lang=js"
export * from "./overlay-loading.vue?vue&type=script&lang=js"
import style0 from "./overlay-loading.vue?vue&type=style&index=0&id=53c9ef24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c9ef24",
  null
  
)

export default component.exports